import classes from './TabButton.module.css';
import clsx from 'clsx';
const TabButton = ({ tab, active, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={clsx(classes.tab, {
        ['activeTabButton']: active
      })}>
      {tab}
    </button>
  );
};
export default TabButton;
